export const SET_REGISTRATION_PROCESSING_STAGE =
  'SET_REGISTRATION_PROCESSING_STAGE'
export const SET_ADDITIONAL_USER_INFO = 'SET_ADDITIONAL_USER_INFO'
